<script setup lang="ts">
type Props = {
  title: string
}
defineProps<Props>()

const { isDesktop } = useDevice()

const onClickToggleView = () => {
  if (isDesktop) {
    return
  }

  isVisibleContent.value = !isVisibleContent.value
}

const isVisibleContent = ref(isDesktop)
</script>

<template>
  <div class="footer-links-item">
    <span class="footer-links-item__title" @click="onClickToggleView">
      {{ title }}
      <nuxt-img
        v-if="!isDesktop"
        :class="{ 'image--reverse': isVisibleContent }"
        src="/arrow-down.svg"
        width="7"
        height="5"
        alt="Стрелка"
        loading="lazy"
      />
    </span>

    <div v-if="isVisibleContent" class="footer-links-item__content">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.footer-links-item {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  &__title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 900;
    line-height: 20px;
    color: $text-grey;

    img {
      margin-left: 10px;
      transition: transform 0.3s ease;
    }

    .image--reverse {
      transform: rotate(180deg);
    }
  }
}
</style>
